// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__35FX6","text":"SelectPayment_text__3up4x","title":"SelectPayment_title__1iDIB","btn":"SelectPayment_btn__20DgM"};